


























































































































/* tslint:disable:only-arrow-functions*/

import {Component, Vue} from 'vue-property-decorator';
import AnimatedInput from '@/components/AnimatedInput.vue';
import LoadingButton from '@/components/LoadingButton.vue';
import {default as KeyUtility} from '../util/keyUtility';
import Letterbox from "../models/Letterbox";
import LetterboxAdapter from "../adapters/letterbox";
import * as Sentry from '@sentry/browser';
import featureFlags from "@/util/featureFlags";
import {Getter} from "vuex-class";
import messageBus from "@/util/messageBus";

@Component({
    components: { AnimatedInput, LoadingButton },
})
export default class LetterboxCreate extends Vue {

    @Getter isLoggedIn!: boolean;

    adapter = new LetterboxAdapter();
    letterboxInfo: Letterbox | null = null;
    errorMessage: string | null = null;
    uriKey: string | null = null;
    letterboxOpenLink: string | null = null;
    letterboxUploadLink: string | null = null;
    letterboxName: string = '';
    agreesToS: boolean = false;

    async startLetterboxCreation() {
      //Check if upload is in free Tier:
      if (!this.isLoggedIn) {
        messageBus.$emit('auth-interactive-needed', "Für diese Funktion ist eine Pro-Mitgliedschaft erforderlich.");
        return;
      }
      try {
          const letterboxKey: CryptoKey = await KeyUtility.generateRandomKey();
          const iv: Uint8Array = KeyUtility.generateIV();
          const base64Key = await KeyUtility.exportKeyToBase64(letterboxKey);
          this.uriKey = encodeURIComponent(base64Key);

          const newLetterbox = new Letterbox();
          newLetterbox.name = this.letterboxName;

          let encryptedLetterbox = await newLetterbox.getEncrypted(letterboxKey, iv);
          encryptedLetterbox = await this.adapter.createLetterbox(encryptedLetterbox);

          this.letterboxInfo = await encryptedLetterbox.getDecrypted(letterboxKey);

          const baseUrl: string = featureFlags.frontendBaseUrl + '/letterbox/';
          this.letterboxOpenLink = baseUrl + this.letterboxInfo.id + '/download#' + this.uriKey;
          this.letterboxUploadLink = baseUrl + this.letterboxInfo.uploadKey + '/upload#' + this.uriKey;

       } catch (e) {
          Vue.$log.error("Letterbox could not be created, exception was thrown", e);
          this.errorMessage = "Es konnte kein neuer Briefkasten erstellt werden.";
          Sentry.captureException(e);
          return;
      }
    }

    copyUploadLinkToClipboard() {
        if (this.letterboxUploadLink) {
            const copyText: HTMLInputElement = document.createElement("input");
            document.body.appendChild(copyText);
            copyText.value = this.letterboxUploadLink;
            copyText.select();
            document.execCommand("copy");
            document.body.removeChild(copyText);
            this.$swal('Erfolg', 'Du kannst den Link z.B. über ' +
                'einen verschlüsselten Messenger verschicken.', 'success');
        }
    }

    copyOpenLinkToClipboard() {
        if (this.letterboxOpenLink) {
            const copyText: HTMLInputElement = document.createElement("input");
            document.body.appendChild(copyText);
            copyText.value = this.letterboxOpenLink;
            copyText.select();
            document.execCommand("copy");
            document.body.removeChild(copyText);
            this.$swal('Erfolg', 'Der Link dient zum Öffnen des Briefkastens. Bewahre ihn gut auf!', 'success');
        }
    }

    mounted() {
      this.$nextTick(() => {
        this.agreesToS = this.isLoggedIn;
      });
    }
}
